import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken } from "@/utils/auth"; // get token from cookie
import getPageTitle from "@/utils/get-page-title";
import Cookies from "js-cookie";
import { getUserType } from "@/api/overseas";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = [
  "/login",
  "/transfer",
  "/loginIn",
  "/register",
  "/home/homepage",
  "/auth-redirect",
  "/ds/",
  "/billLadingEdit",
  "/manifestHyperlinks",
]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {

   // 9月8号自动跳转到booking网站
  //  目标跳转日期（月份0-11，所以8代表9月）
  const currentDate = new Date()
  const targetDate = new Date(2025, 8, 8) // 9月8日 
  if (currentDate > targetDate) {
    window.location.href = 'http://booking.ctsfreight.com'
    return // 中断路由处理流程 
  }

  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);

  // determine whether the user has logged in
  const hasToken = getToken();

  if (hasToken) {
    if (to.path === "/login") {
      /* next({ path: '/' }) */
      var userId = JSON.parse(localStorage.getItem("userInfo")).userId;
      var userTypeParm = {
        sysUserId: userId,
      };
      getUserType(userTypeParm).then((res) => {
        if (res.records === "2") {
          next({ path: "/" });
        }
        if (res.records === "13") {
          next({ path: "/overseas-agency/overseasWelcome" });
        }
      });
      NProgress.done(); // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      // 进入页面前先判断并添加动态路由
      if (!store.state.user.isAddRouters) {
        await store.dispatch("user/getMenu")
      }

      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0;
      if (hasRoles) {
        if (from.path === "/login") {
          if (!store.state.user.isAddRouters) {
            router.addRoutes(store.state.user.routerComponents);
            store.commit("SET_ISADDROUTERS");
          }
        }
        if (to.path === "/VIPPlatform/HuaWei") {
          window.open("http://193.112.15.182/");

          // store.state.tagsView.visitedViews.splice(
          //   store.state.tagsView.visitedViews.findIndex(
          //     (item) => item.path === '/VIPPlatform/HuaWei'
          //   ),
          //   1
          // );

          next({
            path: store.state.tagsView.visitedViews[
              store.state.tagsView.visitedViews.length - 1
            ].path,
          });
        } else {
          next();
        }
      } else {
        // 原跳转首页逻辑，暂时去除
        // if (Cookies.get("refreshWindow") === "1") {
        //   Cookies.set("refreshWindow", 0);
        //   userId = JSON.parse(localStorage.getItem("userInfo")).userId;
        //   userTypeParm = {
        //     sysUserId: userId,
        //   };
        //   getUserType(userTypeParm).then((res) => {
        //     if (to.path !== "/dashboard" && res.records === "2") {
        //       store.dispatch("tagsView/delAllViewsKeepHp").then();
        //       next({ path: "/" });
        //     }

        //     if (
        //       to.path !== "/overseas-agency/overseasWelcome" &&
        //       res.records === "13"
        //     ) {
        //       store.dispatch("tagsView/delAllViewsKeepHp").then();
        //       next({ path: "/overseas-agency/overseasWelcome" });
        //     }
        //   });
        //   NProgress.done();
        // }

        if (to.path === "/VIPPlatform/HuaWei") {
          window.open("http://193.112.15.182/");

          // store.state.tagsView.visitedViews.splice(
          //   store.state.tagsView.visitedViews.findIndex(
          //     (item) => item.path === '/VIPPlatform/HuaWei'
          //   ),
          //   1
          // );

          next({
            path: store.state.tagsView.visitedViews[
              store.state.tagsView.visitedViews.length - 1
            ].path,
          });
        } else {
          // try {
          //   // get user info
          //   // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          //   const { roles } = await store.dispatch('user/getInfo')
          //   // generate accessible routes map based on roles
          //   const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
          //   // dynamically add accessible routes
          //   router.addRoutes(accessRoutes)
          //   /*
          //     提供一个接口getPermission('传入路由')
          //   */
          //   await getPermission(to.path).then(res => {
          //     if (res.data) {
          //       next()
          //     }else {
          //       console.log('用户没有权限')
          //     }
          //   })
          //   .catch(err => {
          //     console.log(err)
          //   })
          // }catch (err) {
          //   // remove token and go to login page to re-login
          //   await store.dispatch('user/resetToken')
          //   Message.error(error || 'Has Error')
          //   next(`/login?redirect=${to.path}`)
          //   NProgress.done()
          // }

          try {
            // get user info
            // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
            // const { roles } = await store.dispatch('user/getInfo')

            // generate accessible routes map based on roles
            // const accessRoutes = await store.dispatch('permission/generateRoutes', 'ADMIN')

            // dynamically add accessible routes
            // router.addRoutes(accessRoutes)

            // hack method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record
            // next({ ...to, replace: true })
            if (store.getters.permission_routes.length) {
              //放行
              next();
            } else {
              // 将路由添加到 store 中，用来标记已添加动态路由
              // generate accessible routes map based on roles
              const accessRoutes = await store.dispatch(
                "permission/generateRoutes",
                "ADMIN"
              );
              // dynamically add accessible routes
              router.addRoutes(accessRoutes);
              // 如果 addRoutes 并未完成，路由守卫会一层一层的执行执行，直到 addRoutes 完成，找到对应的路由
              next({ ...to, replace: true });
            }
          } catch (error) {
            // remove token and go to login page to re-login
            await store.dispatch("user/resetToken");
            Message.error(error || "Has Error");
            next(`/login?redirect=${to.path}`);
            NProgress.done();
          }
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      // next(`/login?redirect=${to.path}`)
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
  if (Cookies.get("refreshWindow")) {
  }
});

// function addRoute (routers,parentRouter) {
//   console.log(routers)
//   routers.forEach(item => {
//     let routeItem = {}
//     if(item.urlType === 'SYSTEM' && !(item.parentResourceId)) {
//        routeItem = {
//         path: '/'+item.url.toLowerCase(),
//         component: Layout,
//         name: item.url.toLowerCase(),
//         hidden: true,
//         children: []
//       }
//       router.addRoute(routeItem)
//     } else if(item.urlType === 'MENU') {
//       let path = '/' + parentRouter.url.toLowerCase() + '/' + item.url.toLowerCase()
//       let component = item.url.slice(0, 1).toUpperCase() + item.url.slice(1)

//       re

//       routeItem = {
//         path: path,
//         component: routerComponent(`@/views/${parentRouter.url.toLowerCase()}/${component}.vue`) ,
//         name: parentRouter.url.toLowerCase()+component,
//         hidden: item.urlParamList === 1,
//       }
//       router.addRoute(parentRouter.url.toLowerCase(),routeItem)
//     }

//     if(routers.children && routers.children.length> 0) addRoute(router.children,routers)
//   })
// }

function routerComponent(path) {
  return (resolve) => require([path], resolve);
}
